import { combineReducers } from 'redux';
import { all, call } from 'redux-saga/effects';
import { publicReducer, userReducer } from './app';
import { AlertState, rootHandleAlertSaga } from './public/alert';
import { BlocklistAccessState, rootBlocklistAccessSaga } from './public/blocklistAccess';
import { ConfigsState, rootConfigsSaga } from './public/configs';
import { CurrenciesState, rootCurrenciesSaga } from './public/currencies';
import { CustomizationState, rootCustomizationSaga } from './public/customization';
import { ErrorHandlerState, rootErrorHandlerSaga } from './public/errorHandler';
import { ColorThemeState } from './public/globalSettings';
import { GridLayoutState } from './public/gridLayout';
import { LanguageState } from './public/i18n';
import { KlineState, rootKlineFetchSaga } from './public/kline';
import { MarketsState, rootMarketsSaga } from './public/markets';
import { MemberLevelsState, rootMemberLevelsSaga } from './public/memberLevels';
import { DepthIncrementState, DepthState, OrderBookState, rootOrderBookSaga } from './public/orderBook';
import { RangerState } from './public/ranger/reducer';
import { RecentTradesState, rootRecentTradesSaga } from './public/recentTrades';
import { AuthState, rootAuthSaga } from './user/auth';
import { BeneficiariesState, rootBeneficiariesSaga } from './user/beneficiaries';
import { CustomizationUpdateState, rootCustomizationUpdateSaga } from './user/customization';
import { DocumentationState, rootDocumentationSaga } from './user/documentation';
import { EmailVerificationState, rootEmailVerificationSaga } from './user/emailVerification';
import { HistoryState, rootHistorySaga } from './user/history';
import { AddressesState, rootSendAddressesSaga } from './user/kyc/addresses';
import { DocumentsState, rootSendDocumentsSaga } from './user/kyc/documents';
import { IdentityState, rootSendIdentitySaga } from './user/kyc/identity';
import { LabelState, rootLabelSaga } from './user/kyc/label';
import { PhoneState, rootSendCodeSaga } from './user/kyc/phone';
import { OpenOrdersState, rootOpenOrdersSaga } from './user/openOrders';
import { OrdersState, rootOrdersSaga } from './user/orders';
import { OrdersHistoryState, rootOrdersHistorySaga } from './user/ordersHistory';
import { PasswordState, rootPasswordSaga } from './user/password';
import { ProfileState, rootProfileSaga } from './user/profile';
// import { AccountInfoState, rootAccountSaga } from './user/infoAccount';
import { rootUserActivitySaga, UserActivityState } from './user/userActivity';
import { rootWalletsSaga, WalletsState } from './user/wallets';
import { rootWithdrawLimitSaga, WithdrawLimitState } from './user/withdrawLimit';
import { TickerGroupState, TickerState } from './public/tickers/reducers';
import { rootTickerGroupSaga } from './public/tickers/sagas';
import { ChartState } from './public/chart/reducers';
import { rootchartSaga } from './public/chart/sagas';
import { PriceBoardState } from './public/price-board/reducers';
import { rootPriceBoardSaga } from './public/price-board/sagas';
import { RankState } from './public/rank/reducers';
import { rootRankSaga } from './public/rank/sagas';
import { ListPriceBoardState } from './public/listPriceBoard/reducer';
import { rootListPriceBoardSaga } from './public/listPriceBoard/sagas';
import { StockOrderBookState } from './public/stock-order-book/reducers';
import { rootStockOrderBookSaga } from './public/stock-order-book/sagas';
import { StockOrderState } from './user/stock-order/reducers';
import { rootStockOpenOrderSaga } from './user/stock-order/sagas';
import { UserAssetsState } from './user/assets/reducers';
import { rootUserAssetsSaga } from './user/assets/sagas';
import { NotificationState } from './user/notifications/reducers';
import { rootNotificationSaga } from './user/notifications/sagas';
import { StockOrderHistoryState } from './user/stock-order-history/reducers';
import { rootStockOrderHistorySaga } from './user/stock-order-history/sagas';
import { rootStockNewsSaga } from './public/company/news/sagas';
import { NewsState } from './public/company/news/reducers';
import { EventsState } from './public/company/events/reducers';
import { rootStockEventsSaga } from './public/company/events/sagas';
import { AIAnalysisState } from './user/ai_analysis/reducer';
import { rootAIAnalysisSaga } from './user/ai_analysis/sagas';
import { ContestState, rootContestSaga } from './public/contest';
import { ContestParticipantState, rootContestParticipantSaga } from './user/contestParticipant';
import { rootTrendingTicketSaga, TrendingTicketState } from './public/TrendingTicket';
import { BannerEventState, rootBannerEventSaga } from './public/bannerEvent';
import { ContestListState, rootContestListSaga } from './public/contestList';

export * from './public/alert';
export * from './public/blocklistAccess';
export * from './public/configs';
export * from './public/currencies';
export * from './public/customization';
export * from './public/errorHandler';
export * from './public/globalSettings';
export * from './public/i18n';
export * from './public/kline';
export * from './public/markets';
export * from './public/memberLevels';
export * from './public/orderBook';
export * from './public/recentTrades';
export * from './public/rank';
export * from './public/contest';
export * from './public/contestList';
export * from './user/auth';
export * from './user/beneficiaries';
export * from './user/customization';
export * from './user/documentation';
export * from './user/emailVerification';
export * from './user/history';
export * from './user/kyc';
export * from './user/openOrders';
export * from './user/orders';
export * from './user/ordersHistory';
export * from './user/password';
export * from './user/profile';
export * from './user/userActivity';
export * from './user/wallets';
export * from './user/withdrawLimit';
export * from './user/contestParticipant';
export interface RootState {
    public: {
        alerts: AlertState;
        blocklistAccess: BlocklistAccessState;
        colorTheme: ColorThemeState;
        configs: ConfigsState;
        currencies: CurrenciesState;
        customization: CustomizationState;
        rgl: GridLayoutState;
        i18n: LanguageState;
        kline: KlineState;
        errorHandler: ErrorHandlerState;
        markets: MarketsState;
        memberLevels: MemberLevelsState;
        orderBook: OrderBookState;
        ranger: RangerState;
        recentTrades: RecentTradesState;
        depth: DepthState;
        incrementDepth: DepthIncrementState;
        tickersGroup: TickerGroupState;
        tickersAll: TickerState;
        chart: ChartState;
        rank: RankState;
        contest: ContestState;
        contestList: ContestListState;
        priceBoard: PriceBoardState;
        listPriceBoard: ListPriceBoardState;
        stockOrderBook: StockOrderBookState;
        companyNews: NewsState;
        companyEvents: EventsState;
        trendingTicket: TrendingTicketState;
        bannerEvent: BannerEventState;
    };
    user: {
        auth: AuthState;
        beneficiaries: BeneficiariesState;
        customizationUpdate: CustomizationUpdateState;
        documentation: DocumentationState;
        history: HistoryState;
        documents: DocumentsState;
        addresses: AddressesState;
        identity: IdentityState;
        label: LabelState;
        phone: PhoneState;
        openOrders: OpenOrdersState;
        orders: OrdersState;
        ordersHistory: OrdersHistoryState;
        password: PasswordState;
        profile: ProfileState;
        // account: AccountInfoState;
        sendEmailVerification: EmailVerificationState;
        userActivity: UserActivityState;
        wallets: WalletsState;
        withdrawLimit: WithdrawLimitState;
        stockOpenOrder: StockOrderState;
        userAssets: UserAssetsState;
        notifications: NotificationState;
        stockOrderHistory: StockOrderHistoryState;
        aiAnalysis: AIAnalysisState;
        contestParticipant: ContestParticipantState;
    };
}

export const rootReducer = combineReducers({
    public: publicReducer,
    user: userReducer,
});

export function* rootSaga() {
    yield all([
        call(rootAuthSaga),
        call(rootBeneficiariesSaga),
        call(rootBlocklistAccessSaga),
        call(rootConfigsSaga),
        call(rootCurrenciesSaga),
        call(rootCustomizationSaga),
        call(rootCustomizationUpdateSaga),
        call(rootDocumentationSaga),
        call(rootErrorHandlerSaga),
        call(rootEmailVerificationSaga),
        call(rootHandleAlertSaga),
        call(rootHistorySaga),
        call(rootKlineFetchSaga),
        call(rootLabelSaga),
        call(rootMarketsSaga),
        call(rootMemberLevelsSaga),
        call(rootOpenOrdersSaga),
        call(rootOrderBookSaga),
        call(rootOrdersHistorySaga),
        call(rootOrdersSaga),
        call(rootPasswordSaga),
        call(rootProfileSaga),
        // call(rootAccountSaga),
        call(rootRecentTradesSaga),
        call(rootSendCodeSaga),
        call(rootSendAddressesSaga),
        call(rootSendDocumentsSaga),
        call(rootSendIdentitySaga),
        call(rootUserActivitySaga),
        call(rootWalletsSaga),
        call(rootWithdrawLimitSaga),
        call(rootTickerGroupSaga),
        call(rootchartSaga),
        call(rootPriceBoardSaga),
        call(rootRankSaga),
        call(rootContestSaga),
        call(rootContestParticipantSaga),
        call(rootListPriceBoardSaga),
        call(rootStockOrderBookSaga),
        call(rootStockOpenOrderSaga),
        call(rootStockNewsSaga),
        call(rootStockEventsSaga),
        call(rootUserAssetsSaga),
        call(rootNotificationSaga),
        call(rootStockOrderHistorySaga),
        call(rootAIAnalysisSaga),
        call(rootTrendingTicketSaga),
        call(rootBannerEventSaga),
        call(rootContestListSaga),
    ]);
}
